<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Cities/elements/Title.vue'

export default {
  name: 'CityForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
